module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMwMDlhMDAiIGQ9Ik0wIDM2MGg2NDB2MTIwSDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDBmIiBkPSJNMCAxMjBoNjQwdjEyMEgweiIvPgogICAgPHBhdGggZmlsbD0icmVkIiBkPSJNMCAwaDY0MHYxMjBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmZjAiIGQ9Ik0wIDI0MGg2NDB2MTIwSDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/mu.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/mu.svg
// module chunks = 0